import React, { useEffect, useState } from "react";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { auth, db } from "../services/firebase";
import { FIRESTORE_USERS_TABLE } from "../constants/FirebaseConstants";
import { onAuthStateChanged } from "firebase/auth";

export const AuthContext = React.createContext({
  authUser: null,
  userProfile: null,
  loading: true,
});

export const useAuthContext = () => React.useContext(AuthContext);

export const AuthContextProvider = ({ children }) => {
  const [authUser, setAuthUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        const docRef = doc(db, FIRESTORE_USERS_TABLE, authUser.uid);
        const docSnap = await getDoc(docRef);
        const userProfile = docSnap.data();
        setAuthUser(authUser);
        setUserProfile(userProfile);

        return onSnapshot(
          doc(db, FIRESTORE_USERS_TABLE, authUser.uid),
          (doc) => {
            setUserProfile(doc.data());
            setLoading(false);
          },
        );
      } else {
        setAuthUser(null);
        setUserProfile(null);
      }
      setLoading(false);
    });

    return () => unsubscribeAuth && unsubscribeAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ authUser, userProfile, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
